var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliateBinary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.978,
    height: 17.529,
    viewBox: "0 0 27.978 17.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Affiliate_Binary_Plan",
    "data-name": "Affiliate Binary Plan",
    transform: "translate(-23 -38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    fill: "rgba(255, 255, 255, 0.40)",
    "data-name": "Path 24",
    d: "M48.956,48.787h-2.7a1.967,1.967,0,0,0-.876.2L39.989,43.6a1.967,1.967,0,0,0,.2-.876v-2.7A2.028,2.028,0,0,0,38.169,38h-2.7a2.028,2.028,0,0,0-2.023,2.023v2.7a1.967,1.967,0,0,0,.2.876L28.36,48.888a1.962,1.962,0,0,0-.64-.1h-2.7A2.028,2.028,0,0,0,23,50.809v2.7a2.028,2.028,0,0,0,2.023,2.023h2.7a2.028,2.028,0,0,0,2.023-2.023v-2.7a1.714,1.714,0,0,0-.337-1.079L34.6,44.539a1.967,1.967,0,0,0,.876.2h2.7a1.967,1.967,0,0,0,.876-.2l5.393,5.393a1.967,1.967,0,0,0-.2.876v2.7a2.028,2.028,0,0,0,2.023,2.023h2.7a2.028,2.028,0,0,0,2.023-2.023v-2.7A2.028,2.028,0,0,0,48.956,48.787ZM28.393,53.506a.676.676,0,0,1-.674.674h-2.7a.676.676,0,0,1-.674-.674v-2.7a.676.676,0,0,1,.674-.674h2.7a.676.676,0,0,1,.674.674Zm7.079-10.113a.676.676,0,0,1-.674-.674v-2.7a.676.676,0,0,1,.674-.674h2.7a.676.676,0,0,1,.674.674v2.7a.676.676,0,0,1-.674.674ZM49.63,53.506a.676.676,0,0,1-.674.674h-2.7a.676.676,0,0,1-.674-.674v-2.7a.676.676,0,0,1,.674-.674h2.7a.676.676,0,0,1,.674.674Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateBinary);
export default __webpack_public_path__ + "static/media/AffiliateBinary.61eb5d2a.svg";
export { ForwardRef as ReactComponent };